import { motion } from "framer-motion";
import About from "../components/About";
import { useLanguage } from "../context/LanguageContext";

export default function AboutPage() {
  const { t, dir, lang } = useLanguage();
  const a = t.aboutPage;
  return (
    <>
      <section
        dir={dir}
        lang={lang}
        className="relative pt-40 pb-6 px-5 sm:px-8"
        data-testid="about-page-hero"
      >
        <div className="mx-auto max-w-7xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-agency-gold flex items-center gap-3">
            <span className="h-px w-8 bg-agency-gold" /> {a.eyebrow}
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="mt-6 font-display text-5xl md:text-7xl font-black tracking-[-0.03em] max-w-4xl"
          >
            {a.heading1}{" "}
            <span className="gradient-gold-text">{a.headingGold}</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 max-w-2xl text-white/60 text-base md:text-lg"
          >
            {a.sub}
          </motion.p>
        </div>
      </section>
      <About />
    </>
  );
}
